import $ from 'jquery';
import 'ez-plus';
import './stylitics-toggle';
import 'styleguide/modules/slides';
import './size-selection';
import './add-to-bag';
import './add-buy-now';
import './notify-me';
import './chat-window-qa';
import './sticky-bound';
import './jquery-zoom';
import breaky from 'breaky';
import getReviews from './customer-reviews';
import { revieveTryOn, revieveAddToBag } from '../../modules/revieve-try-on';
import { revieveMakeupAdvisor} from "../../modules/revieve-makeup-advisor";
import { renderPdpSocialProof } from "../../modules/social-proof";
import { pdpAddToBag } from './add-to-bag-function';
import initInfluencerShareLink from 'modules/influencer-share-link';
import { addToBagWithData } from '../../modules/add-to-bag';
import { logEngagementWithDetails } from "../../modules/global/log-engagement";

const rcProps = window.rcProps || {};
const {
    fullViewPath = '',
    currentModelCountParam = -1
} = rcProps.pdp || {};
const arabDir = $('html').attr('dir');
const rtlBool = arabDir ? true : false;

window.showMeasurementGuide = function (modalOptions = {}) {
    if(rcProps.hasOwnProperty('pdpSizeGuideUrl') && rcProps.pdpSizeGuideUrl.length) {
        if (rcProps.hasOwnProperty('fitPredictor') && rcProps.fitPredictor.showDynamicSizeGuide) {
            ssp('start', 'sizeguide');
            ssp('track', 'triggerSizeGuide', {
                productId: rcProps.fitPredictor.code,
                origin: 'sizeguide-cta'
            });
        }

        const modalDefaultOptions = {
            url: rcProps.pdpSizeGuideUrl,
            triggerOpen: true,
            returnFocus: '#js-sizeguide-focus',
        };
        const modalSettings = $.extend({}, modalDefaultOptions, modalOptions);

        $.modal(modalSettings);
    } else {
        $.modal({
            url:'/r/dialog/ProductMessages.jsp?error=yes'
        });
    }
}
window.showMeasurementGuideTabs = function () {
    if(rcProps.hasOwnProperty('pdpSizeGuideUrl') && rcProps.pdpSizeGuideUrl.length) {
        if (rcProps.hasOwnProperty('fitPredictor') && rcProps.fitPredictor.showDynamicSizeGuide) {
            ssp('start', 'sizeguide');
            ssp('track', 'triggerSizeGuide', {
                productId: rcProps.fitPredictor.code,
                origin: 'sizeguide-cta'
            });
        }

        $.modal({
            url: rcProps.pdpSizeGuideUrl,
            triggerOpen: true,
            returnFocus: '#js-size-guide-focus-tabs',
            onComplete: function(){
              $('.js-accordion').accordion();
              $('.js-tabs').tabs();
            }
        });
    } else {
        $.modal({
            url:'/r/dialog/ProductMessages.jsp?error=yes'
        });
    }
}

// Requires for Zelig Add to Cart integration
window.addToBagWithData = function(data, callback) {
    if (!data.count && $(".js-counter-value").length) {
        data.count = $(".js-counter-value").text();
    }
    if ($('#replenish-save').is(':checked')){
        data.subscriptionInterval = $('#subscription-interval option:selected').val();
    }

    addToBagWithData(data, callback);
};

function handleZeligWidgetLoaded() {
    $('.js-sticky-bound .zelig-widget').stickyBound({
        fixedClass: 'sticky-bound--is-fixed',
        centerInContainer: true,
        containerSelector: null,
        throttleWait: 50,
    });
}

$(()=>{

    // Can't Find Your Size
    $('.js-cant-find-size').on('click', function() {
        $.modal({
            url: './sizeModal.html',
            triggerOpen: true,
        })
    })

    // BIS One Size
    $('.js-bis-one-size').on('click', function() {
        $.modal({
            url: './bisOneSizeModal.html',
            type: 'small',
            triggerOpen: true,
        })
    })

    function runFitPredictor() {
        const onPrediction = (data) => {
            $('#size-ul input').each(function() {
                if($(this).data('size') === data.size) {
                    $(this).click();
                }
            });
        };

        if (rcProps.hasOwnProperty('fitPredictor') && rcProps.fitPredictor.show) {
            ssp('subscribe', 'prediction', onPrediction);
            ssp('start', 'fitpredictor');
            ssp('start', 'stylefinder');
        }
    }

    /**
     * Custom Slick Options for PDP Full Image View
     */
    const fullProductImageView = (startIndex = 0) => {

        /* Initialize Jquery Zoom  */
        const initZoom = ($carousel) => {

            const $zoomActive = $carousel.find('.slick-active');

            // Clear any existing zoom instances first
            $carousel.find('.js-pdp-image-zoom.zoom-active').each(function() {
                $(this).trigger('zoom.destroy');
                $(this).removeClass('zoom-active');
            });

            // Initialize zoom on active slides
            $zoomActive.each(function(i, el) {

                // Set cursor to crosshair
                el.style.cursor = "crosshair";

                const $zoomContainer = $(el).find('.js-pdp-image-zoom');
                const zoomImgUrl = $zoomContainer.data('zoom-img');

                if (zoomImgUrl && !$zoomContainer.hasClass('zoom-active')) {
                    $zoomContainer.zoom({
                        on: 'click-n-grab', // NEW: Mouse Event for settings option
                        magnify: 2,
                        // ONLY works when on is set to click-n-grab
                        moveDirection: 'reverse', // Set to 'reverse' for inverted drag
                        onZoomIn: function () {
                            el.style.cursor = "grab";
                        },
                        onZoomOut: function () {
                            el.style.cursor = "crosshair";
                        }
                    });
                    $zoomContainer.addClass('zoom-active');
                }
            });
        }

        const $carousel = $('.js-product-full-view');
        const thumbCount = $('.js-full-view-thumb .js-primary-slideshow__pager-thumb').length;
        const $slickThumbs = $('.js-full-view-thumb');

        if(!$carousel.hasClass('slick-initialized')) {

            $carousel.on('init', function(event, slick) {
                const $slickList = $carousel.find('.slick-list');
                const $slickTrack = $carousel.find('.slick-track');
                $slickList.addClass('u-height--full u-scroll-y');
                $slickTrack.addClass('u-height--full');

                initZoom($carousel);

                /* Mock Content Start UX-20630 */
                // Give the zoom-modal video the same custom skin as the PDP
                // gallery — a centered play/pause overlay revealed on hover —
                // instead of the browser's native (bottom-left) controls.
                $carousel.find('.js-full-view-video').each(function() {
                    if (this.dataset.skinned) return;
                    this.dataset.skinned = 'true';
                    $(this).customVideoPlayer({
                        videoMuted: false,
                        hideMute: true, // renders the mute/volume button (flag is inverted)
                        $originalTrigger: $('.js-floating-video-button').first(),
                    });
                });
                /* Mock Content End UX-20630 */
            })
            .on('afterChange', (event, slick) => {
                initZoom($carousel);
            });

            const splitImageBreakpoint = 1190;
            let slidesToShowNum = 2;

            if (thumbCount >= 2) {
                $carousel.on('breakpoint', function (event, slick, breakpoint) {
                    if(breakpoint === splitImageBreakpoint && slick.options.slidesToShow < thumbCount) {
                        $slickThumbs.show();
                        $slickThumbs.slick('setPosition');
                    } else if (breakpoint === null && slick.options.slidesToShow >= thumbCount) {
                        $slickThumbs.hide();
                    }
                })
            } else {
                slidesToShowNum = 1;
                $slickThumbs.show();
            }

            $carousel.slick({
                lazyLoad: 'progressive',
                nextArrow: "#js-product-full-view-next",
                prevArrow: "#js-product-full-view-prev",
                asNavFor: '.js-full-view-thumb',
                draggable: false, // to fix weird parallax with jQuery Zoom JS
                rtl: rtlBool,
                slidesToShow: slidesToShowNum,
                slidesToScroll: 1,
                initialSlide: startIndex,
                responsive: [
                    {
                      breakpoint: splitImageBreakpoint,
                      settings: {
                        slidesToShow: 1,
                      }
                    }
                  ]
            });

            $("#js-product-full-view-prev").on('click', function() {
                logEngagementWithDetails(window.location.href, 'pdp zoom modal',
                    'left swipe', 'PDP clicking on left arrow');
            });

            $("#js-product-full-view-next").on('click', function() {
                logEngagementWithDetails(window.location.href, 'pdp zoom modal',
                    'right swipe', 'PDP clicking on right arrow');
            });

            $('.js-full-view-video').on('click', function() {
                const module = `PDP ${$(this).data('videoLocation')}`;
                logEngagementWithDetails(
                    window.location.href,
                    module,
                    'Video Click',
                    $(this).data('videoId')
                );
            });

            $slickThumbs.slick({
                asNavFor: '.js-product-full-view',
                vertical: true,
                focusOnSelect: true,
                arrows: false,
                centerMode: false,
                slidesToShow: thumbCount,
                verticalSwiping: true,
                initialSlide: startIndex,
            })

            $slickThumbs.on('click', '.slick-slide', function () {
                const clickedThumbIndex = $(this).data('slick-index');
                logEngagementWithDetails(window.location.href, 'pdp zoom modal',
                    'click thumbnail', 'PDP clicking on thumbnail image on the left');
                $carousel.slick('slickGoTo', clickedThumbIndex);
            });
        }
    }

    function changePDPColorText(colorText) {
        // unescape for chinese
        colorText = unescape((colorText || '').replaceAll(/\\u/ig, '%u'));
        $('.selectedColor').html(colorText);

    };

    function revertSelectedPDPColorText() {
        const checkedSwatch = $('.ui-list input:checked')[0];
        const checkedSwatchColor = checkedSwatch.getAttribute('value')
        $('.selectedColor').html(checkedSwatchColor);
    }

    // Swap swatch color image with Main Image
    function swapMainImage(elem) {
      const $imageSrcToReplaceWith = elem.attr('data-image');
      const $imageSrcSetToReplaceWith = elem.attr('data-srcset');
      const $primarySlideshowImage = $('#js-primary-slideshow__image');
      $primarySlideshowImage.attr('src', $imageSrcToReplaceWith);
      $primarySlideshowImage.attr('srcset', $imageSrcSetToReplaceWith);
    };

    function initSizeJs() {
        $('.js-product-info .cantfindsize').off('click').on('click', function() {
            const $this = $(this);
            var showPopup = $(this).data("showPopup");
            if (showPopup === 'special-order') {
                showSOPopup(this);
            } else if (showPopup === 'notify-me') {
                showNotifyMePopup(this);
            } else {
                showFullPopup(this);
            }
            if ($this.data('disabledSize') && typeof logEngagementWithDetails === 'function') {
                logEngagementWithDetails(window.location.href, 'PDP Sizes',
                    'Disabled size clicked', $this.data('sizeSelected'));
            }
        });
        $('.js-size-option').sizeSelection();
        $('#js-sizeguide-focus').on('click', function() {
            const type = $(this).data('type') || '';
            showMeasurementGuide({type});
        });
        $('.js-similar-items-modal').on('click', function(e) {
            const $targetEl = $(e.target);
            $.modal({
                url: $targetEl.data('url'),
                type: 'half',
                overlayClose: true,
                triggerOpen: true,
                returnFocus: $targetEl,
                onComplete: function() {
                    const $favoriteButtons = $('.modal').find('.js-favorite-button');
                    if (window.bindHeartEvent) {
                        window.bindHeartEvent($favoriteButtons);
                        $favoriteButtons.on('click', function() {
                            logEngagementWithDetails(window.location.href, 'oos similar recs', 'heart', $(this).data('code'));
                        });
                    }
                    $('.js-lazy-image').lazy();
                    $('.js-progressive-button').progressiveButton();
                    $('#js-bis-notify-me').notifyMe();
                    $('.js-add-to-bag').on('click', function() {
                        const $el = $(this);
                        pdpAddToBag(null, {
                            code: $el.data('code'),
                            size: $el.data('size'),
                            src: 'oossimilar_atc',
                        });
                        logEngagementWithDetails(window.location.href, 'oos similar recs', 'atc', $el.data('code'));
                    });
                }
            });
            logEngagementWithDetails(window.location.href, 'oos similar recs', 'open recs', `${$targetEl.data('code')}+${$targetEl.data('size')}`);
        });
    }

    function initPDPJs() {
        const getImageHeight = () => {
            const $imageParentEl = $('.js-pdp-image-zoom');
            const $jsSlideShowVideo = $('.js-slideshow__vid'); // Group A (not left/right arrow)
            const setMaxHeight = 650;
            const dynamicHeight = $(window).height() - $('header').height() - 70; // 70 to give a buffer
            const maxHeight = dynamicHeight > setMaxHeight ? setMaxHeight : dynamicHeight;
            if ($jsSlideShowVideo.length) {
                $jsSlideShowVideo.find('video').css('max-height', maxHeight);
            }
            if ($imageParentEl.length) {
                $('.js-slides__pdp-vid').find('video').css('max-height', maxHeight);
            }
        }
        const productImageView = () => {
            $('.js-slides').slides({
                adaptiveHeight: true,
                nextArrow: $('.js-slides').find('.slick-next'),
                prevArrow: $('.js-slides').find('.slick-prev'),
                showZoomTab: true,
                lazyLoad: 'progressive', // switched to progressive because of adaptiveHeight
                asNavFor: '.js-primary-slideshow__pager',
                dots: false,
                waitForAnimate: false
            });
            const SELECTORS = {
                GALLERY_CONTAINER: '.js-slides--two-column',
                GALLERY_SLICK: '.js-slides--two-column-slick',
                GALLERY_SLICK_VIDEOS: '.js-slides--two-column-slick video:not(.ab3461)',
                GALLERY_NAV_CONTAINER: '.js-slides--two-column-nav',
                GALLERY_NAV_SLICK: '.js-slides--two-column-nav-slick',
            };

            if ($('.ab3461').length) {
                $('.ab3461').trigger('play');
                makeAutoplayVideosAccessible();
            }

            // apply custom video players to videos
            $(SELECTORS.GALLERY_SLICK_VIDEOS).customVideoPlayer();

            if ($(SELECTORS.GALLERY_CONTAINER).length) {
                $(SELECTORS.GALLERY_SLICK).removeClass('u-flex');
                if (!$(SELECTORS.GALLERY_SLICK).hasClass('slick-initialized')) {
                    $(SELECTORS.GALLERY_CONTAINER).slides({
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        adaptiveHeight: false,
                        arrows: true,
                        showZoomTab: true,
                        lazyLoad: 'progressive',
                        dots: false,
                        rtl: rtlBool,
                        waitForAnimate: false,
                        nextArrow: $(SELECTORS.GALLERY_CONTAINER).find('.slick-next'),
                        prevArrow: $(SELECTORS.GALLERY_CONTAINER).find('.slick-prev'),
                        asNavFor: SELECTORS.GALLERY_NAV_SLICK,
                        responsive: [
                            {
                                breakpoint: 900,
                                settings: {
                                    slidesToShow: 1,
                                }
                            },
                        ],
                    });
                    $(SELECTORS.GALLERY_NAV_SLICK).on('init', function() {
                        if ($('.js-cotton-seal').length) {
                            $('.js-cotton-seal').show();
                        }
                    });
                    const navItemCount = $(SELECTORS.GALLERY_NAV_SLICK)
                        .find('.slideshow--gallery__nav-item').length;
                    $(SELECTORS.GALLERY_NAV_CONTAINER).slides({
                        asNavFor: SELECTORS.GALLERY_SLICK,
                        dots: false,
                        focusOnSelect: true,
                        slidesToShow: Math.max(navItemCount, 1),
                        infinite: false,
                        slidesToScroll: 1,
                        waitForAnimate: false,
                        adjacentSlidesBorder: true,
                        arrows: false,
                        rtl: rtlBool,
                    });
                }

                makeAutoplayVideosAccessible();

                $(SELECTORS.GALLERY_SLICK).on('beforeChange', function(_, slick, currentSlide, nextSlide) {
                    const $slickElCurrent = $(slick.$slides.get(currentSlide));
                    const $slickElNext = $(slick.$slides.get(nextSlide));
                    // const $slickVid = $slickEl.find('video');
                });

                $(SELECTORS.GALLERY_SLICK).on('afterChange', function(_, slick) {
                    /* Mock Content Start UX-20630 */
                    $(slick.$slides).each(function() {
                        const $slide = $(this);
                        const $slideVid = $slide.find('video');
                        // ab3461 videos autoplay on init and are handled separately;
                        // `.length` is required — a jQuery object is always truthy.
                        if (!$slideVid.length || $slide.find('.ab3461').length) return;

                        if ($slide.hasClass('slick-active')) {
                            $slideVid.trigger('play');
                        } else {
                            $slideVid.trigger('pause');
                        }
                    });
                    /* Mock Content End UX-20630 */
                });

                if ($('.slideshow--gallery__nav-item').length >= 2) {
                    $(SELECTORS.GALLERY_CONTAINER).find('.slick-next').removeClass('u-hide');
                    $(SELECTORS.GALLERY_CONTAINER).find('.slick-prev').removeClass('u-hide');
                } else {
                    $('.slideshow--gallery__nav').addClass('u-hide');
                }

                $(SELECTORS.GALLERY_SLICK_VIDEOS).on('play', function() {
                    const $thisVid = $(this);

                    $(SELECTORS.GALLERY_SLICK_VIDEOS).each(function() {
                        const $otherVid = $(this);

                        if (!$thisVid.is($otherVid)) {
                            $otherVid.trigger('pause');
                        }
                    });
                });
            }
            function makeAutoplayVideosAccessible() {
                $('.ab3461').each(function() {
                    const $video = $(this);

                    $video.attr({
                        'aria-label': 'Product demonstration video, playing automatically',
                        'role': 'img',
                    });
                });
            }
            $('.js-slides__pdp-vid').on('beforeChange', function(_, slick, currentSlide, nextSlide) {
                const $slickEl = $(slick.$slides.get(nextSlide));
                if (nextSlide !== currentSlide) {
                    $('.js-slideshow__vid video:not(.ab3461)').each(function(i, item) {
                        item.pause();
                    })
                }
                const $videoPlayBtn = $slickEl.find('.js-slideshow__vid-play-btn');
                const $videoWrapper = $slickEl.find('.js-slideshow__vid');
                if ($videoPlayBtn.length > 0) {
                    $videoWrapper.css('display', 'flex'); // adds flex to video due to border
                    $videoPlayBtn.click();
                }
                getImageHeight();
            })
        }

        $(window).on('init resize', function() {
            getImageHeight();
        });

        productImageView();

        $('div.zoomWindow').remove();
        initColorSwatchesJs();

        $("#special-order").click(function(){
            showSOPopup(this);
        });

        $('.js-toggle-change').toggleChange();

        const $stylSlideImg = $('#js-stylitics-slideshow-image');
        const $stylImageContainer = $('.js-main-stylitics-image-container');
        const $slideImageContainer = $('.js-main-default-image-container');
        let styliticsProduct = '';
        let styliticsRelatedProduct = '';
        let styliticsSrcTag = '';

        $stylImageContainer.on('click', function() {
            loadQuickViewForProducts(styliticsProduct, styliticsRelatedProduct.split(','), styliticsSrcTag);
        });

        const zoomModalSettings = {
            type: 'full',
            onPrepend: () => {
                /* Mock Content Start UX-20630 */
                // Pause the inline gallery video when the zoom modal opens so its
                // audio doesn't stack with the zoom modal's own video (double sound).
                $('.js-floating-video-button video').each(function() {
                    if (!this.paused) this.pause();
                });
                /* Mock Content End UX-20630 */
                logEngagementWithDetails(window.location.href, 'pdp zoom modal',
                    'open zoom', 'PDP clicking on/opening zoom modal');
                const windowWidth = $(window).width();
                const shouldShowTwoImages = windowWidth > 1190;
                const thumbCount = $('.js-full-view-thumb .slideshow__pager-thumb').length <= 2;
                const $slickThumbs = $('.js-full-view-thumb');
                const $navArrows = $('.slideshow__nav');

                if (shouldShowTwoImages && thumbCount) {
                    $slickThumbs.hide();
                    $navArrows.hide();
                }
            },
            onClose: () => {
                logEngagementWithDetails(window.location.href, 'pdp zoom modal',
                    'exit zoom', 'PDP zoom model closed');
            },
        }

        const $mainGallery = $('.js-slides-slick');
        let adjustedIndex;

        $mainGallery.on('mouseup', function(e) {
            var $li = $(e.target).closest('.slick-slide');
            var slickIndex = $li.data('slick-index');
            // Find the leftmost visible slide in the current view
            // Check if there's a slide to the left that's also visible
            var $leftSibling = $li.prev('.slick-slide:not(.slick-cloned)').filter('.slick-active');
            adjustedIndex = $leftSibling.length ? $leftSibling.data('slick-index') : slickIndex;
        });

        $('.js-primary-slideshow-wrapper .js-zoom-modal').on("click", function () {
            let fullViewUrl = $('#primary-slideshow-btn').data('url');
            const currentSlide = $('.js-primary-slideshow__pager-thumb.active').data('slide');
            adjustedIndex = Number(currentSlide);
            $.modal({...zoomModalSettings, url:fullViewUrl, triggerOpen: true, onComplete: () => {
                fullProductImageView(adjustedIndex);
                $('.js-product-full-view .slideshow__image').removeClass('u-hide');
                }});
        })

        $('.js-slides--two-column .js-zoom-modal').modal({...zoomModalSettings, triggerByClick: false, onComplete: () => {
            fullProductImageView(adjustedIndex);
        }});

        $('.js-slideshow__vid-play-btn').on('click', function() {
            $(this).addClass('u-hide');
            const video = $(this).closest('.js-slideshow__vid').find('video')
            video[0].play();
        })

        const rcProps = window.rcProps || {};
        // Add to my list
        $('.js-my-list').on('click',function() {
            const productCode = $(this).data('code');
            if (typeof logEngagementWithDetails === 'function') {
                logEngagementWithDetails(window.location.href, 'PDP',
                    'click', 'PDP add to my list clicked');
            }
            $.modal({
                url: window.rcProps.hearts.addToMyListsModalHref,
                type: 'small',
                triggerOpen: true,
                returnFocus: $(this),
                onComplete: function() {
                    $('.js-toggle-change').toggleChange();
                    if ($('.js-my-list-body').height() >= 320) {
                        $('.js-my-list-body').css('border-bottom', 'thin solid #e4e4e4');
                    }
                    $('.js-my-list-added').on('click', function() {
                        let lists = "";
                        $('.js-checkbox-saved-list').each(function (i, e) {
                            if ($(e).is(':checked')) {
                                lists += "&lists=" + $(e).data('id');
                            }
                        });
                        if (lists === "") {
                            if ($('.js-create-list-input').is(':visible') && $('#new-list').val().trim() == "") {
                                $('#creatNewListError').html('Please enter a list name');
                                $('.js-create-list-input').find('div.field').addClass('is-error');
                                $('#new-list').on('keypress', function () {
                                    $('.js-create-list-input').find('div.field').removeClass('is-error');
                                });
                                return;
                            } else if($('.js-checkbox-saved-list').length === 0 && !$('.js-create-list-input').is(':visible')){
                                $('#list-not-created-error').removeClass('u-hide');
                                $('.js-checkbox-saved-list').on('click', function () {
                                    $('#list-not-created-error').addClass('u-hide');
                                });
                                return;
                            } else if($('.js-checkbox-saved-list').length > 0 && !$('.js-create-list-input').is(':visible')) {
                                $('#no-list-selected-error').removeClass('u-hide');
                                $('.js-checkbox-saved-list').on('click', function () {
                                    $('#no-list-selected-error').addClass('u-hide');
                                });
                                return;
                            }
                        }
                        $.ajax({
                            url: window.rcProps.hearts.addProductToListHref + "?product=" + productCode +"&newListName=" + $('#new-list').val() + lists ,
                            type: "POST",
                            success: function (returnData) {
                                $('.js-create-list-input').find('div.field').removeClass('is-error');
                                if (returnData.errorMessage) {
                                    $('#creatNewListError').html(returnData.errorMessage);
                                    $('.js-create-list-input').find('div.field').addClass('is-error');
                                } else {
                                    if (typeof logEngagementWithDetails === 'function') {
                                        logEngagementWithDetails(window.location.href, 'PDP My List',
                                            'Product added', 'Product added to list');
                                    }
                                    $.modal({
                                        url: window.rcProps.hearts.addToMyListConfirmModalHref + "?product=" + productCode + '&d=' + rcProps.siteDepartment + "&newListName=" + $('#new-list').val() + lists,
                                        type: 'small',
                                        triggerOpen: true,
                                    })
                                }
                            }
                        });
                    })
                }
            });
        });

        //star rating scale for pdp review modal
        $("#pdp-review-modal .js-rating-scale").ratingScale({
            titleSelector: '.form-section__title'
        });

        initSizeJs();

        //heart product button
        if (window.bindHeartEvent) {
            window.bindHeartEvent($(".js-product-info .js-favorite-button"));
        }

        $(".js-toggle-row").toggleRow();



        $('.js-alt-view-video').on('click', function() {
            const module = `PDP ${$(this).data('videoLocation')}`;
            logEngagementWithDetails(
              window.location.href,
              module,
              'Video Click',
              $(this).data('videoId')
            );
        });

        $('#addtobagbutton, #addtobagbutton_preorder').addToBag();
        $('#buynowbutton').addBuyNow();

        if ($('.card--multiple-models').length) {
            initializeMultipleModels();
        }

        if ($('#details-markup-holder').html().trim().length === 0) {
            insertStylisticsByAjax();
        }

        if (window.rcProps.revieveEventEnabled) {
            revieveTryOn();
        } else {
            $(window).on('revieveScriptLoaded', function() {
                revieveTryOn();
            });
        }

        revieveMakeupAdvisor();
        getInfluencerMarkup();
        renderPdpSocialProof(window.rcProps.pdp.code);
    }

    function getInfluencerMarkup() {
        if (rcProps.influencerShareLinkHref) {
            $.get(rcProps.influencerShareLinkHref, (data) => {
                $('#social-influencer-share-link').html(data);
            });
        }

        if (rcProps.influencerShareBannerHref) {
            $.get(rcProps.influencerShareBannerHref, (data) => {
                $('#social-influencer-share-banner').html(data);
            });
        }
    }

    // For multiple models A/B test https://revolve.atlassian.net/browse/AB-632
    // NOTE: Adding a variable to the outer scope to keep track of current model.
    let currentModelCount = -1;
    function initializeMultipleModels() {
        const $sizeEl = $('.card--multiple-models__size');
        const $heightEl = $('.card--multiple-models__height');

        $('.js-model-switch').on('click', function() {
            const { modelCount, modelHeight, modelSize, totalModelNum, modelNum } = $(this).data();
            const logData = { modelHeight, modelSize, modelNum };

            // Prevent further execution if user clicks on currently selected model
            if (parseInt(modelCount) === currentModelCount) {
                return;
            }

            currentModelCount = modelCount;

            $sizeEl.text(modelSize);
            $heightEl.text(modelHeight);

            $(`#model-${modelCount}-images`).show();

            if ($(this).attr('id') !== `tab-${modelCount}`) {
                $(`#tab-${modelCount}`).click();
            }
            if ($(this).attr('id') !== `ctl-model-tab-${modelCount}`) {
                $(`#ctl-model-tab-${modelCount}`).click();
            }
            for (let i = 1; i <= totalModelNum; i++) {
                if (i !== modelCount) {
                    $(`#model-${i}-images`).hide();
                }
            }
            logEngagementWithDetails(
                window.location.href,
                'PDP Change Model',
                'Size Change',
                JSON.stringify(logData)
            );
            $('.js-slides--two-column-slick:visible, .js-slides--two-column-nav-slick:visible').slick('setPosition');
            if ($('.multiple-models-2-column').length <= 0) {
                swapMainImage($('.slideshow__pager-thumb').first());
                $(`#model-${modelCount}-images > button`).first().trigger('mouseenter');
                let fullViewUrl = fullViewPath + `&${currentModelCountParam}=${modelNum}`
                $('#primary-slideshow-btn').data('url', fullViewUrl);
            }
        });
    }

    function updateSizeData() {
        const opts = Object.assign({}, $('.product-sizes').data());
        const productCodes = opts.productCodes ? opts.productCodes.split(',') : [];

        if (productCodes.length) {
            if(!$.isEmptyObject(window.rcProps.productData)) {
                applySizeData(opts, window.rcProps.productData, productCodes);
            } else {
                $.ajax({
                    type: 'GET',
                    url: '/r/ajax/GetProductData.jsp',
                    data: {
                        product: productCodes,
                        department: $('#header-jsp').data('department'),
                    },
                    success: function (rtn) {
                        window.rcProps.productData = rtn;
                        applySizeData(opts, rtn, productCodes);
                    }
                });
            }
        }

        if (opts.preselectedSize) {
            $('#sizeValue').val(opts.preselectedSize);
            $(`#size-options-${opts.preselectedSizeId}`).click();
        } else if (opts.isOneSize) {
            $('#size-options-one-size').click();
        } else {
            $('#size-options-no-size').click();
        }
    }

    function applySizeData(opts, data, productCodes) {
        const productCode = window.rcProps.pdp.code;
        const isOneSize = opts.isOneSize;
        const useRealTimeInventory = opts.realTimeInventory;
        const jsonData = parseRtn(data);
        const productData = jsonData[productCode];
        const sizes = productData.inventory;
        const otherCodesOutOfStockBySize = sizes.reduce(function(result, item) {
            result[item['size']] = [];
            return result;
        }, {})

        for (let i = 0; i < productCodes.length; i++) { // figure out which codes are OOS (default to available to prevent incorectly marking as OOS)
            const colorwayCode = productCodes[i];
            if (colorwayCode === productCode) { // current PDP separately handles the sizes so no need to process here
                continue;
            }
            if (jsonData[colorwayCode]) {
                const colorwaySizes = jsonData[colorwayCode].inventory;
                if (colorwaySizes) {
                    for (let j = 0; j < colorwaySizes.length; j++) {
                        const colorwaySize = colorwaySizes[j];
                        const oos = colorwaySize.quantity === 0;
                        if (oos) {
                            const sizesOos = otherCodesOutOfStockBySize[colorwaySize.size];
                            if (sizesOos) {
                                sizesOos.push(colorwayCode);
                            }
                        }
                    }
                }
            }
        }

        let sizeOptionsObj = {};
        $('.js-size-option').each(function() {
            sizeOptionsObj[this.id] = false;
        });

        for (let i = 0; i < sizes.length; i++) {
            const size = sizes[i];
            const sizeValue = isOneSize ? 'one-size' : size.size;
            const price = size.priceAmount ? size.priceAmount : productData.priceAmount;
            const priceFormatted = size.price ? size.price : productData.price;
            const retailPrice = size.retailPriceAmount ? size.retailPriceAmount : productData.retailPriceAmount;
            const retailPriceFormatted = size.retailPrice ? size.retailPrice : productData.retailPrice;
            const id = `size-options-${(isOneSize ? 'one-size' : size.sizeForId)}`;
            const input = $(`#${id}`);
            if (input) {
                const nowDisabled = size.quantity <= 0;
                input.data('colorsOos', otherCodesOutOfStockBySize[sizeValue]);
                if (useRealTimeInventory) { // only change these data attributes if using cached sizes for PDP
                    input.data('code', size.code)
                        .data('qty', size.quantity)
                        .data('isPreorder', size.preOrderOnly)
                        .data('price', price)
                        .data('priceFormatted', priceFormatted)
                        .data('regularPrice', retailPrice)
                        .data('regularPriceFormatted', retailPriceFormatted)
                        .data('onSale', price < retailPrice)
                        .data('finalSale', size.disclaimer && size.disclaimer.indexOf('FINAL SALE') > -1)
                        .data('inventoryDisclaimer', size.disclaimer)

                    input.prop('disabled', nowDisabled);
                    delete sizeOptionsObj[id];
                }

                if (isOneSize || input.is(':checked')) { // (e.g., pre-selected size that can now indicate OOS for other colorways)
                    input.click();
                }
            }
        }

        if (useRealTimeInventory) {
            for (let key in sizeOptionsObj) { // disable any sizes that weren't processed
                $(`#${key}`).prop('disabled', true);
            }
        }
    }

    function getLazyLoadSizeModule() {
        if (!rcProps.hasOwnProperty('lazyLoadSizeModule')) {
            return false;
        }
        const dataForSizeModule = {
            productCode: rcProps.lazyLoadSizeModule.productCode,
            fpCode: rcProps.lazyLoadSizeModule.fpCode,
            sectionUrl: rcProps.lazyLoadSizeModule.sectionUrl,
            cantFindSizeText: rcProps.lazyLoadSizeModule.cantFindSizeText,
            showSizePopup: rcProps.lazyLoadSizeModule.showSizePopup,
        }

        $.ajax({
            type: 'GET',
            url: rcProps.lazyLoadSizeModule.path,
            data: dataForSizeModule,
            success: function(rtn){
                const _sizeMarkupDiv = $('#lazy-load-size-module');
                if (rtn && rtn.sizeMarkup && _sizeMarkupDiv.length) {
                    _sizeMarkupDiv.html(rtn.sizeMarkup);
                    updateSizeData();
                    initSizeJs();
                    runFitPredictor();
                    if (typeof window.placeTangibleeCta === 'function') {
                        window.placeTangibleeCta();
                    }
                }
            },
            error: function () {
                console.error('An error about lazyloading sizes has occurred');
            },
        });
    }

    function showFullPopup(elem) {
        var data = $.param({
            allSize : $(elem).data("allSize"),
            isAllPreorder: $(elem).data("isAllPreorder"),
            oosSize : $(elem).data("oosSize"),
            sectionURL : $(elem).data("sectionurl"),
            code : $(elem).data("code"),
            sizeSelected : $(elem).data("sizeSelected")
        });
        const rcProps = window.rcProps || {};

        $.modal({
            url : rcProps.backInStockSpecialOrderHref,
            data: data,
            triggerOpen: true,
            returnFocus: $(elem),
            onComplete: function(){
              $('.js-progressive-button').progressiveButton();
            }
        });
    }

    function showNotifyMePopup(elem) {
        var data = $.param({
            allSize : $(elem).data("allSize"),
            isAllPreorder: $(elem).data("isAllPreorder"),
            oosSize : $(elem).data("oosSize"),
            sectionURL : $(elem).data("sectionurl"),
            code : $(elem).data("code"),
            d : $(elem).data("dept"),
            sizeSelected : $(elem).data("sizeSelected")
        });
        $('#modal').remove();
        $.modal({
            url : "/r/dialog/BackInStockPopup.jsp",
            data: data,
            type: 'small',
            triggerOpen: true,
            returnFocus: $(elem),
            onComplete: function(){
              $('.js-progressive-button').progressiveButton();
            }
        });
    }

    function showSOPopup(elem) {
        var data = $.param({
            allSize : $(elem).data("allSize"),
            oosSize : $(elem).data("oosSize"),
            code : $(elem).data("code"),
            d : $(elem).data("dept"),
            sizeSelected : $(elem).data("sizeSelected")
        });
        $.modal({
            url : "/r/dialog/SpecialOrderPopup.jsp",
            data: data,
            type: "small",
            triggerOpen: true,
            returnFocus: $(elem),

        });
    }

    function colorClicked(code, url, size) {
        if(!$.isEmptyObject(window.rcProps.colorSwatchData) && !$.isEmptyObject(window.rcProps.colorSwatchData[code])) {
            applyColor(window.rcProps.colorSwatchData[code], code, url, size);
        } else {
            $.ajax({
                type: "POST",
                url: "/content/product/getMarkup/" + code,
                data: $.param({
                    originalPlpSrc: window.rcProps.pdp.plpSrc,
                    originalRef: window.rcProps.pdp.ref
                }),
                success: function (result) {
                    window.rcProps.colorSwatchData = window.rcProps.colorSwatchData || {};
                    window.rcProps.colorSwatchData[code] = result;
                    applyColor(result, code, url, size);
                }
            });
        }
    }

    function applyColor(result, code, url, size) {
        if (result.success && result.markup) {
            window.rcProps.pdp.code = code;

            let selectedSize;
            const isSwatchListView = $('#viewToggle').prop('checked');
            //js-modal moves this out of the markup that gets replaced
            let markup = result.markup;
            if (isSwatchListView) {
                markup = markup.replaceAll("product-swatches u-margin-t--none js-ct-swatches", "product-swatches u-margin-t--none js-ct-swatches product-swatches--list");
                markup = markup.replaceAll("product-swatches__name js-tooltip-content tooltip__content tooltip__content--top tooltip__content--top--sm", "product-swatches__name js-tooltip-content");
                markup = markup.replaceAll("data-ct-toggle-class", "checked data-ct-toggle-class");
            }
            $("#pdp-review-modal").remove();
            $(".js-product-info").html(markup);
            $(".size-options__item").each(function(index, el) {
              let sizeOption = $(el).find("input[type=radio]");
              if (sizeOption && size === sizeOption.val() && !sizeOption.prop('disabled') && sizeOption.data('qty') !== 0) {
                  selectedSize = sizeOption;
              }
            });

            $(".size-options__item").css("opacity", 0).animate({ opacity: 1 }, 800);

            $(".js-product-full-view-container").html(result.fullViewImages);
            getReviews({}, 1)

            initPDPJs();

            $(".product-swatches--collapse").productSwatches();

            if (selectedSize && typeof selectedSize !== 'undefined') {
                $(selectedSize).trigger("click");
            }

            // reload similar items
            if ($("#you-may-also-like").length) {
                $.get(`/content/product/pdp-content/${code}/similarItems`, {}, result => {
                    $("#you-may-also-like").empty().append(result);
                    $('.js-lazy-image').lazy();
                    $(".js-toggle-reveal").toggleReveal()
                });
            }

            if (url) {
                insertPageTrackWithInfo(url, true, window.location.href);
                window.history.replaceState({
                    code: code,
                    colorClicked: true
                }, result.title, url);
                document.title = result.title;
            }

            // check if favorite state should be adjusted based on actions since retrieved
            const $heartButton = $('.js-product-info .js-favorite-button');
            if (window.productHearts && window.productHearts.hasOwnProperty(code) && $heartButton.length){
                const favoriteActiveClass = window.rcProps && window.rcProps.favoriteActiveClass;
                if (window.productHearts[code]) {
                    $heartButton.addClass(favoriteActiveClass);
                    $heartButton.attr('aria-checked', true);
                } else {
                    $heartButton.removeClass(favoriteActiveClass);
                    $heartButton.attr('aria-checked', false);
                }
            }
        } else {
            if (result.error) {
                console.log(result.error);
            } else {
                //recaptcha, do nothing for now
            }
        }
    }

    function preloadColors() {
        if($(".js-product-swatch").toArray().every(li=>{return $(li).data('useAjax')})) {
            window.rcProps = window.rcProps || {};
            window.rcProps.colorSwatchData = {};
            window.rcProps.productData = {};

            let codes = [];

            $(".js-product-swatch").each(function (idx, li) {
                let code = $(li).data("swatchCode");
                codes.push(code);
            });

            if (codes.length > 0) {
                $.ajax({
                    type: "POST",
                    url: "/content/product/getMarkup/",
                    data: $.param({
                        originalPlpSrc: window.rcProps.pdp.plpSrc,
                        originalRef: window.rcProps.pdp.ref,
                        codes: codes
                    }),
                    success: function (result) {
                        codes.forEach(function (code) {
                            if (!$.isEmptyObject(result[code])) {
                                window.rcProps.colorSwatchData[code] = result[code];
                            }
                        });
                    }
                });

                $.ajax({
                    type: 'GET',
                    url: '/r/ajax/GetProductData.jsp',
                    data: {
                        product: codes,
                        department: $('#header-jsp').data('department'),
                    },
                    success: function (rtn) {
                        window.rcProps.productData = rtn;
                    }
                });
            }
        }
    }

    function initColorSwatchesJs() {
        $('.js-product-swatch').on('mouseover', function() {
            if($('div.zoomWindow').length) {
                const $this = $(this);
                const $colorSwatch = $this.attr('data-color-name');
                changePDPColorText($colorSwatch);
                swapMainImage($this);
            }
        });

        $('.js-product-swatch').on('mouseout', function() {
            if($('div.zoomWindow').length) {
                revertSelectedPDPColorText();
                const $activePrimaryThumb = $('.js-primary-slideshow__pager-thumb.active');
                swapMainImage($activePrimaryThumb);
            }
        });

        function colorSwatchSwap(elem) {
            var url = $(elem).data("swatch-url");
            var size = $('input[name="size-options"]:checked').val();
            var sizeVal = $('#sizeValue').val();
            if(sizeVal && sizeVal != undefined) {
                url += ((url.indexOf('?') >= 0) ? '&' : '?') + $.param({sizeVal: sizeVal});
            }
            if (size && typeof size !== 'undefined') {
                url += ((url.indexOf('?') >= 0) ? '&' : '?') + $.param({size: size});
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                if (urlParams.get('sizeSelected') === 'true') {
                    url += ((url.indexOf('?') >= 0) ? '&' : '?') + $.param({sizeSelected: true});
                }
            }

            if ($('#viewToggle').prop('checked')) {
                url += ((url.indexOf('?') >= 0) ? '&' : '?') + $.param({swatchListView: true});
            } else {
                url = url.replace(/[?&]swatchListView=true/, '');
            }
            if ($(elem).data("use-ajax")) {
                colorClicked($(elem).data("swatch-code"), url, size);
            } else {
                document.location.href = url;
            }
        }
        $(".js-product-swatch, .js_fit_style_button").on("click", function(e) {
            colorSwatchSwap(this);
            e.preventDefault();
        });

        $('.js-product-swatch, .js_fit_style_button').on('keydown', function(e) {
            if (e.keyCode === 13) {
                colorSwatchSwap(this);
            }
        });
    }
    //AB test 568 - chat window
    $('.js-chat-window').chatWindow();
    //AB test 568 - chat window

    window.colorClicked = colorClicked;

    $(function() {
        //Complete the look
        var completeTheLookBlock = $('.js-complete-the-look-block');
        var completeTheLook = $('.js-complete-the-look');
        var discoverMore = $('.js-discover-more');

        completeTheLook.removeClass('u-hide--visible');

        //Tablet View and Below
        breaky.below("tablet", function() {
            completeTheLookBlock.removeClass('block--lg');
            completeTheLookBlock.addClass('block--xl');
            discoverMore.addClass('gc');
            discoverMore.removeClass('u-overflow--hidden');

            //Add pagination that is consistent with other carousel modules on the page
            completeTheLookBlock.find('.carousel__nav-inner').children('span').wrap('<div class="btn btn--circle btn--circle--lg"></div>');
        });

        // Small-Desktop View and Above
        breaky.above("small-desktop", function() {
            completeTheLookBlock.removeClass('block--xl');
            completeTheLookBlock.addClass('block--lg');

            //Reset to OG pagination
            completeTheLookBlock.find('.btn--circle').children('span').unwrap();
        });

        $('.js-yt-slideshow__vid-play-btn').on('click', function() {
            var $this = $(this);
            const videoDivUrl = $this.parent().data('video-url');
            const modalIframeVideoId = '#js-modal-iframe-video';
            const playBtnId = $this.attr('id');
            // open ajax video modal
            $.modal({
                url: "/content/video/beauty/modal",
                video: true,
                data: $.param({
                    videoId: $this.data("videoId")
                }),
                triggerOpen: true,
                onComplete: function(){
                    const yt = videoDivUrl.includes('youtube.com');
                    let command;
                    if (yt) {
                        command = {
                            "event": "command",
                            "func": "playVideo",
                            "args": ""
                        }
                    } else {
                        command = {
                            "method": "play",
                            "value": "true"
                        }
                    }
                    $(modalIframeVideoId).on('load', function(){
                        // play video once iframe is loaded
                        videoStatus(modalIframeVideoId, command);
                    });
                },
                onClose: function() {
                    $('.js-slideshow-iframe').each(function () {
                        const yt = {
                            "event": "command",
                            "func": "pauseVideo"
                        }
                        const vimeo = {
                            "method": "pause",
                            "value": "true"
                        }
                        videoStatus(this, yt)
                        videoStatus(this, vimeo)
                    });
                },
                returnFocus: `#${playBtnId}`
            });
        })

        function ifVideoMedia(el) {
            // if media is video
            if($(el).data('media') == 'video') {
                const $vertical = $(el).data('vertical');
                const $videoURL = $(el).data('video-url');
                const $iframeSRC = $('iframe[src="'+$videoURL+'"]');
                const isInternalVideo = $(el).data('is-internal-video');
                if($vertical) {
                    $('.video-modal').addClass('video-modal--vertical');
                } else {
                    $('.video-modal').removeClass('video-modal--vertical');
                }
                if($iframeSRC.length == 0 && !isInternalVideo){
                    $('.slideshow__vid-container').append('<iframe class="js-track-video js-slideshow-iframe slideshow__vid" data-event-category="Camila Coelho" src="'+$videoURL+'" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
                    $('.js-track-video').trackVideo();
                }
                $('#beauty-video-' + $(el).data('videoCount')).css('display', 'flex'); // sets video to flex due to border issues
                $('.js-zoom-modeal-control').hide();
            // if media is image
            } else {
                $('.js-zoom-modeal-control').show();
                $('.js-slideshow__vid-control').hide();
            }
        }

        function showVideo(el) {
            // hide all videos
            $('.js-slideshow__vid-control').hide();
            $('.js-slideshow-iframe').hide();
            // $('.js-main-stylitics-image-container').addClass('u-hide');
            ifVideoMedia(el);
        }

        // video in pdp
        $('.slideshow__pager-thumb').on('mouseenter', function(){
            showVideo(this);
        });

        $('#js-primary-slideshow__pager button').on('keyup', function(event) {
            const keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '13'){
                $(this).mouseenter();
            }
        });

        function videoStatus(selector, command) {
          $(selector)[0].contentWindow.postMessage(JSON.stringify(command), '*');
        }
    });

    const colorsContainer = $('#colors-container');
    if (colorsContainer.data("ajax")) {
        $.get(window.rcProps.pdp.colorSwatchesUri + "?code=" + window.rcProps.pdp.code).then((markup) => {
           colorsContainer.html(markup);
            initColorSwatchesJs();
        });
    }

    const styleExpertBannerContainer = $('.js-style-expert-container');
    if (styleExpertBannerContainer.is('[data-ajax]')) {
        $.get(window.rcProps.pdp.styleExpertBannerUri + "?code=" + window.rcProps.pdp.code).then((markup) => {
            styleExpertBannerContainer.html(markup);
        });
    }

    initPDPJs();

    if (rcProps.hasOwnProperty('lazyLoadSizeModule')) {
        getLazyLoadSizeModule();
    } else {
        updateSizeData();
        runFitPredictor();
    }

    preloadColors();

    $('#recently-viewed, #recommended-for-you, #you-may-also-like, #you-may-also-like-fs, .js-discover-more-ab').lazyAjax({
        afterLoad: function ($el) {
            $('.js-tabs', $el).tabs();
            $(".js-toggle-reveal", $el).toggleReveal();
            $('.js-carousel', $el).slickSlider({
                responsive: [{
                    breakpoint: 899,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4
                    }
                }]
            });
            $('.js-lazy-image').lazy();
            $el.css('aspect-ratio', '');
            },
        onFinishedAll: function() {
            $('.js-similar-items').removeClass('product-sections__similar-items');
        }
    });

    if (rcProps.abtests.personalizedPla) {
        $(document).on('click', '.js-personalized-pla-tag', function (event) {
            const tag = $(this).data('personalized-pla-tag');
            if (tag && tag.toString().trim() !== '') {
                const params = new URLSearchParams(window.location.search);
                params.set("selectedPlaTag", tag); // safely adds/updates
                window.history.pushState({}, '', `${window.location.pathname}?${params.toString()}`);
            }
        });
        $(document).on('click', '.js-personalized-pla-more', async () => {
            try {
                const productCode = document.querySelector('.js-personalized-pla-container').dataset.personalizedPlaCode;
                const container = document.querySelector('.js-personalized-pla-tagged-tab.tabs__content--active');
                const tag = container.dataset.personalizedPlaTag;
                const index = container.querySelectorAll('.js-personalized-pla-tagged-tab-cell').length;

                const url = new URL('/content/personalized-pla/' + productCode + '/view-more/', window.location.origin);
                url.searchParams.set('selectedPlaTag', tag);
                url.searchParams.set('index', index);
                const res = await fetch(url.toString())
                const html = await res.text();
                container.insertAdjacentHTML('beforeend', html);
            } catch (err) {
                console.error(err);
            }
        });
        $('#personalized-pla').lazyAjax({
            afterLoad: function ($el) {
                $('.js-tabs-ab', $el).tabs();
            },
        });
    }

    function loadQuickViewForProducts(productCode, otherProductCodes, trackingTag, requestURL, callBackAfterAddToBag) {
        if(event) {
            event.preventDefault();
        }
        var data = $.param({
            code: productCode,
            otherCodes: otherProductCodes,
            requestURL: $.trim(requestURL) ? requestURL : window.location.href,
            callBackAfterAddToBag: callBackAfterAddToBag
        });

        $.modal({
            url: "/r/dialog/QuickView.jsp?" + data + (typeof trackingTag !== 'undefined' ? '&' + trackingTag : ''),
            type: "large",
            triggerOpen: true,
            returnFocus: '#qv-open-' + productCode,
            onComplete: function() {
                $('.js-carousel__qv-main').slickSlider({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    nextArrow: ".js-carousel__qv-main-next",
                    prevArrow: ".js-carousel__qv-main-prev",
                    infinite: true
                });
                $('.product-swatches--collapse').productSwatches();
                $('.js-toggle-row').toggleRow();

                if(window.bindHeartEvent){
                    window.bindHeartEvent($('.modal').find('.js-favorite-button'));
                }

                var sizeClickables = $('.modal:visible .size-options__radio');
                autoCheckSizeOption(sizeClickables);
            }
        });

    }

    window.loadQuickViewForProducts = loadQuickViewForProducts;

    function autoCheckSizeOption(sizeClickables){
        if(!sizeClickables || sizeClickables.length == 0)
            return;

        if(sizeClickables.length == 1){
            sizeClickables.eq(0).click();
        }else if(sizeClickables.length > 1){
            var sizeClickableCount = 0;
            var sizeToClick;
            sizeClickables.each(function(){
                if(!$(this).prop('disabled')){
                    sizeClickableCount++;
                    sizeToClick = $(this);
                }
            });
            if(sizeClickableCount === 1 && sizeToClick && sizeToClick.length === 1){
                sizeToClick.click();
            }
        }
    }

    /*
        js-ctas
        =========
        CTA width is set to full if drop to more then one line
    */
    const ctaWrapHeight = $(".js-ctas").height();
    const ctaItem = $(".js-ctas__item");
    const ctaItemHeight = ctaItem.height();
    if (ctaWrapHeight > ctaItemHeight) {
        ctaItem.addClass("u-full-width");
        ctaItem.first().addClass('u-margin-b--lg');
    }

    /*
        Model Info Hide/Show
        Track Engagement
        ====================
    */
    $('.js-track-model-info-link').mouseover(function () {
        logEngagement(window.location.href, 'Model Info Link', 'Mouse Over');
    });

    if(window.location.href.indexOf("AddToList=true") > -1){
        var newURL = location.href.replace("AddToList=true", "");
        window.history.pushState('object', document.title, newURL);
        if($('a.js-my-list').length){
            $('a.js-my-list').click();
        }
    }

    if (!window.rcProps.pdp.hideReviews) {
        getReviews({}, 1)
    }

    // Mock Changes Start
    function insertStylisticsByAjax() {
        $.ajax({
            type: 'GET',
            url: $('#details-markup-holder').data('uri'),
            success: function (data) {
                $('#details-markup-holder').append(data);
                var detailsTab = $('#details-ajaxed-tab').detach();
                $('#product-details').replaceWith(detailsTab);
                var secondaryDetails = $('#secondary-tab').detach();
                $('#product-secondary-content').replaceWith(secondaryDetails);
                // needed
                if (rtlBool) {
                    $('#secondary-tab').css({ clear: 'both', float: 'left' });
                    $('#secondary-tab .carousel__nav-prev').css('right', '-30px');
                    $('#secondary-tab .carousel__nav-next').css('left', '-30px');
                }
                initialzeDetailsTabNstylisticsContainer();
                $('.js-dropdown').dropdown();
                $('.js-modal').modal();
                if ($('.card--multiple-models').length) {
                    initializeMultipleModels();
                }
                const $floatingVideoBtn = $('.js-floating-video-button');
                if ($floatingVideoBtn.length) {
                    $floatingVideoBtn.floatingVideo();
                    $floatingVideoBtn.on('click', function() {
                        logEngagementWithDetails(
                            window.location.href,
                            'PDP Sticky Video',
                            'Video Click',
                            $(this).data('videoId')
                        );
                    });
                }

                const $employeeVideoBtn = $('.js-emp-floating-video-button');
                if ($employeeVideoBtn.length) {
                    $employeeVideoBtn.floatingVideo();
                    $employeeVideoBtn.on('click', function() {
                        logEngagementWithDetails(
                            window.location.href,
                            'PDP Size and Fit',
                            'Video Click',
                            'productcode=' + $(this).data('pcode')
                        );
                    });
                }
            }
        });
    }
    // Mock Changes End

    function initialzeDetailsTabNstylisticsContainer() {
        $(".js-product-info .js-tabs").tabs();
        $(".js-accordion").accordion();
        const isAb995 = $('.js-product-info .js-carousel-ctl').data('ab995');

        if (isAb995) {
            const tabletBreakpoint = window.matchMedia('(max-width: 900px)');
            const $wrap = $('.pdp__cpl-wrap');
            const $slider = $('.js-product-info .js-carousel-ctl'); // slickSlider initializer
            const $track = $slider.find('.js-carousel__track'); // slick element
            const $tabItems = $('#details-ajaxed-tab ul').find('li');
            const $firstTabItem = $tabItems.first();
            $slider.slickSlider({
                slidesToShow: 4,
                slidesToScroll: 4,
                infinite: false,
            });

            const handleBreakpoint = (e) => {
                if (e.matches) {
                    $wrap.css({ visibility: 'hidden', display: 'block' });
                    $track.slick('setPosition');
                    $wrap.css({ visibility: ''});
                    $('.js-zelig-recommneded-looks').hide();
                    $firstTabItem.find('a').trigger('click');
                } else {
                    $wrap.css({ visibility: '', display: '' });
                    $('.js-zelig-recommneded-looks').show();
                    $tabItems.eq(1).find('a')[0].click();
                }
            };

            tabletBreakpoint.addEventListener('change', handleBreakpoint);
            handleBreakpoint(tabletBreakpoint);

        } else {
            $('.js-product-info .js-carousel-ctl').slickSlider({
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 1020,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 900,
                        settings: {
                            slidesToShow: 4,
                            slidesToScroll: 4,
                        }
                    }
                ]
            });
        }

        $('#js-size-guide-focus-tabs').on('click touchstart', function () {
            showMeasurementGuideTabs();
        });
        $('.js-track-sizeguide-click').click(function () {
            logEngagement(window.location.href, 'Size Guide Link', 'Click');
        });
        $('.js-track-size-fit-tab').click(function () {
            logEngagement(window.location.href, 'Size Fit Tab', 'Click');
        });
        $(".js-tabs-size-guide").tabs({
            tab: ".tabs-size-guide__link",
            tabActive: 'tabs-size-guide__link--active',
            tabContentActive: 'sizeguide-tab-content--active'
        });
        $('.js-carousel-ctl-stylitics').slickSlider({
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false
        });

        if ($('.js-shop-more-looks').length > 0) {
            $('.js-shop-more-looks').on('click', function () {
                const $currentFocus = $(document.activeElement);
                $.modal({
                    url: $(this).data('href'),
                    type: 'ctl',
                    method: 'get',
                    triggerOpen: true,
                    returnFocus: $currentFocus,
                    onComplete: function ({content}) {
                        const $content = $(content);
                        $('.js-carousel__shop-more').slickSlider({
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            dots: true,
                            accessiblePaging: true,
                            nextArrow: $content.find(".exp__next"),
                            prevArrow: $content.find(".exp__prev"),
                            infinite: true,
                            lazyLoad: "progressive",
                        });
                        $('.js-tabs').tabs();
                    }
                });
                logEngagementWithDetails(window.location.href, 'PDP Outfit Suggestion',
                  'click', '');
            });
        }
    }

    // Fit Predictor Tracking
    $('body').on('DOMNodeInserted', '.sf-cta-wrapper', function() {
        logEngagementWithDetails(window.location.href, 'PDP Style Finder', 'Eligible Item', window.rcProps.pdp.code);
    });

    $('body').on('click', '.fp-root', function() {
        logEngagement(window.location.href, 'Fit Predictor', 'click');
    });

    const styleFinderCode = $(".sf-product-code").html();
    if (styleFinderCode) {
        $('.sf-root').click(() => {
            $.ajax({
                type: 'POST',
                url: '/r/ajax/LogStyleFinderEngagement.jsp',
                data: $.param({
                    code: styleFinderCode.trim()
                }),
            });
        });
    }

    initInfluencerShareLink();
    revieveAddToBag();
});

document.addEventListener("DOMContentLoaded", function() {
    let processed = false;

    const observer = new MutationObserver(function(mutationsList, observer) {
        if (processed) return;

        const widgetElement = document.querySelector('.yotpo-widget-instance');
        if (!widgetElement) return;

        const fullText = document.querySelector('.yotpo-bottom-line-basic-text');
        if (!fullText) return;

        processed = true;

        if (document.querySelector('.yotpo-widget-instance.ab929')) {
            const fullTextReviewNum = fullText?.textContent.match(/[\d,]+/)?.[0] || '';
            fullText.textContent = `${fullTextReviewNum} Review${fullTextReviewNum !== '1' ? 's' : ''}`;
        }

        const reviewElement = document.querySelector('.yotpo-sr-bottom-line-text.yotpo-sr-bottom-line-text--right-panel');
        if (reviewElement) {
            // remove stars
            widgetElement.style.display = 'none';
        }

        observer.disconnect();
    });

    // Start observing the document body for added nodes
    observer.observe(document.body, { childList: true, subtree: true });
});

document.addEventListener('zeligWidgetLoaded', function(e) {
    handleZeligWidgetLoaded();
});

document.addEventListener('WidgetModalOpen', function(e) {
    logEngagement(window.location.href, 'Zelig', 'PDP widget clicks');
});

document.addEventListener('hue-add-to-cart', (e) => {
    const code = e.detail.variantId;
    let size;
    if ($('#size-ul').length) {
        size = $(`#size-ul li input[data-code="${code}"]`).data('sizeValue');
    } else {
        size = $('#sizeValue').val();
    }

    pdpAddToBag(null, { code: code, size: size });
    $('.hue-cart-menu-header__close').click();
});

document.addEventListener('hue-integration', (e) => {
    const { detail } = e;
    if (detail.type === 'video-popup-open') {
        logEngagementWithDetails(window.location.href, 'hue', 'open modal', rcProps.pdp.code);
    }
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/pdp/index.js